<section class="trip-preferences" [class.trip-preferences--hidden]="!showTripPreferences">
  <div class="trip-preferences__header">
    <p>My preferences</p>
    <button mat-ripple (click)="buttonEvent.emit()">
      <mat-icon [svgIcon]="eSvgIcons.CLOSE_THIN"></mat-icon>
    </button>
  </div>
  <div class="trip-preferences__content">
    <div class="trip-preferences__sliders">
      @for (slider of preferenceSliders; track $index) {
        <div class="trip-preferences__slider">
          <app-trip-slider
              [preferenceSlider]="slider"
              (onSliderChange)="updateSlider($event)">
          </app-trip-slider>
        </div>
      }
    </div>
  </div>
</section>
